
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { ClinicOfficeListService } from 'src/shop-manager/services/clinic-office-list.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.css'],
  standalone: false
})
export class MapDialogComponent implements AfterViewInit
{
  bounds = new google.maps.LatLngBounds();
  markers: any[] = []
  @ViewChild(GoogleMap) map!: GoogleMap

  infoContent: {
    name: string,
    id: string,
    city: string,
    zipCode: string,
    addressLine1: string
  } = {
      name: '',
      id: '',
      city: '',
      zipCode: '',
      addressLine1: ''
    }

  constructor(private clinicOfficeListService: ClinicOfficeListService)
  { }

  ngAfterViewInit(): void
  {
    this.clinicOfficeListService.loadedClinicOfficeListSubject.pipe(first(l_val => l_val == true)).subscribe(() =>
    {
      Promise.resolve().then(() =>
      {
        this.clinicOfficeListService.data.forEach(l_clinicOffice =>
        {
          if (l_clinicOffice.shown)
          {
            this.addMarker(
              Number(l_clinicOffice.geolocation.latitude),
              Number(l_clinicOffice.geolocation.longitude),
              l_clinicOffice.clinicOfficeId,
              l_clinicOffice.name,
              l_clinicOffice.city,
              l_clinicOffice.zipCode,
              l_clinicOffice.addressLine1
            );
          }
        });
      });
    })
  }

  public openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow, name: string, id: string, city: string, zipCode: string, addressLine1: string)
  {
    this.infoContent = {
      name: name,
      id: id,
      city: city,
      zipCode: zipCode,
      addressLine1: addressLine1
    }
    infoWindow.open(marker);
  }

  addMarker(lat: number, lng: number, id: string, name: string, city: string, zipCode: string, addressLine1: string)
  {

    let marker = {
      position: {
        lat: lat,
        lng: lng,
      },
      label: {
        color: 'black',
        text: id
      },
      id: id,
      title: name,
      city: city,
      zipCode: zipCode,
      addressLine1: addressLine1
      // options: { animation: google.maps.Animation.BOUNCE },
    }
    this.bounds.extend(new google.maps.LatLng(lat, lng));
    this.map.fitBounds(this.bounds);
    this.markers.push(marker);
  }



}